import { render, staticRenderFns } from "./loanRepaymentDetail.vue?vue&type=template&id=087834f5&scoped=true&"
import script from "./loanRepaymentDetail.vue?vue&type=script&lang=js&"
export * from "./loanRepaymentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087834f5",
  null
  
)

export default component.exports